import React from "react";
import { useNavigate } from "react-router-dom";
import { LogoLockup } from "../components/brand/Brand";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center paper-grain px-6" data-testid="payment-cancel-page">
      <LogoLockup className="h-16" />
      <div className="lr-card p-8 mt-8 max-w-md w-full text-center">
        <XCircle className="h-8 w-8 text-lr-clay mx-auto" />
        <h1 className="font-serif text-2xl text-lr-charcoal mt-5">Payment canceled</h1>
        <p className="mt-3 text-sm text-lr-charcoal/80">
          No charge was made. Whenever you are ready, you can start your Business Assessment. If you would rather talk first, that is always welcome.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => navigate("/")} data-testid="cancel-home-btn"
            className="bg-lr-olive hover:bg-[#3d4230] text-lr-cream rounded-[4px]">Back to home</Button>
        </div>
      </div>
    </div>
  );
}
